import { EntityInput, forCreate, forUpdate, forDelete } from '../common/entity';
import { ReorderRuleExportConfiguration } from './reorderRuleExportConfiguration';

export class ReorderRuleExportConfigurationInput
  extends ReorderRuleExportConfiguration
  implements EntityInput<ReorderRuleExportConfiguration>
{
  forCreate(): CreateReorderRuleExportConfigurationInput {
    return CreateReorderRuleExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateReorderRuleExportConfigurationInput,
    );
  }

  forUpdate(): UpdateReorderRuleExportConfigurationInput {
    return UpdateReorderRuleExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateReorderRuleExportConfigurationInput,
    );
  }

  forDelete(): DeleteReorderRuleExportConfigurationInput {
    return DeleteReorderRuleExportConfigurationInput.from(this, DeleteReorderRuleExportConfigurationInput);
  }
}

export class CreateReorderRuleExportConfigurationInput extends forCreate(ReorderRuleExportConfiguration) {}

export class UpdateReorderRuleExportConfigurationInput extends forUpdate(ReorderRuleExportConfiguration) {}

export class DeleteReorderRuleExportConfigurationInput extends forDelete(ReorderRuleExportConfiguration) {}
